import { legacyApplication } from './LegacyApplication';

/*
    This class is intended to be used as a place to store info about the current user
    See "LegacyApplication" for more info on how this class inteacts with the values
    used by the old jQuery code base
*/

class CurrentUser {
  getAttribute(name) {
    let value = legacyApplication.getAttribute(name);
    if (value) {
      return value;
    } else {
      return localStorage.getItem(name);
    }
  }

  setAttribute(name, value) {
    localStorage.setItem(name, value);
    legacyApplication.setAttribute(name, value);
  }

  removeAttribute(name) {
    localStorage.removeItem(name);
    legacyApplication.removeAttribute(name);
  }
}

export let currentUser = new CurrentUser();
